import React, { SVGProps } from 'react';

const SvgCustomSecurity = (props: SVGProps<SVGSVGElement>) => (
    <svg 
        xmlSpace='preserve'  
        width="1em" height="1em" 
        viewBox="0 0 18 20" 
        fill="none" 
        className='svg-icon' {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M8.91535 0.524545C8.96585 0.491818 9.03415 0.491818 9.08465 0.524545C11.6372 2.17898 14.4014 3.21294 17.3793 3.62653C17.4594 3.63765 17.5 3.69909 17.5 3.75V9.375C17.5 11.6968 16.7953 13.6856 15.4069 15.3576C14.0118 17.0376 11.9031 18.4253 9.05565 19.49C9.02004 19.5033 8.97996 19.5033 8.94435 19.49C6.09687 18.4253 3.98818 17.0376 2.59312 15.3576C1.20474 13.6856 0.5 11.6968 0.5 9.375V3.75C0.5 3.69909 0.540616 3.63765 0.620727 3.62653C3.59856 3.21294 6.3628 2.17898 8.91535 0.524545ZM10.1429 10.8459C10.9029 10.4485 11.4286 9.66387 11.4286 8.75C11.4286 7.42514 10.3279 6.375 9 6.375C7.67211 6.375 6.57143 7.42514 6.57143 8.75C6.57143 9.66387 7.09705 10.4485 7.85714 10.8459V13.125C7.85714 13.7595 8.38219 14.25 9 14.25C9.61781 14.25 10.1429 13.7595 10.1429 13.125V10.8459Z" stroke="black" strokeOpacity="0.6"/>
    </svg>

);

export default SvgCustomSecurity;